import { Button, Col, Form, Input, Row, Space, Table, Tooltip, Typography, message, notification } from "antd";
import React, { useEffect, useImperativeHandle, useMemo, useState } from "react";
import { columnsTableMenu, optionsLieuDung } from "./ServiceTable.config";
import "./ServiceTable.scss";
import { DataTableMenu } from "./ServiceTable.config";
import {
  Medicine,
  UnitMedicine,
  UsageMedicine,
} from "types/models/examination-diagnostic-type";
import { medicineStoreService, medicalExaminationService } from "api";
import { unitStoreService } from "api";
import { usageStoreService, storeService, examOutService } from "api";
import { useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import Icons from "assets/icons";
import SaveNewGoiThuoc from "./SaveNewGoiThuoc/SaveNewGoiThuoc";
import { EXAM_BTN_CLICK_TYPE } from "types/enums/examination";

const ServiceTable = React.forwardRef((props, ref) => {

  // redux

  //
  //
  const [dataSource, setDataSource] = useState<any>([]);
  const [count, setCount] = useState(1);
  useImperativeHandle(ref, () => ({
    setData: (data) => {
      setCount(data.length + 1);
      setDataSource(data)
    },
    getData: () => {
      return dataSource;
    },
    validateFields: validateFields
  }))
  const [dichVus, setDichVus] = useState<any>([])
  const searchDMDichVu = async () => {
    try {
      let response = await examOutService.searchDMDichVu({
        tenDichVu: ""
      });
      setDichVus(response)
    } catch (err) {
      
    }
  }
  const validateFields = async () => {
    let tmp = dataSource.find( it => isNaN(Number(it.soLan)) || !it.tenDichVu || it.tenDichVu === "" || isNaN(it.giaTri) );
    return tmp ? false: true;
  }
  useEffect(() => {
    searchDMDichVu()
  }, []);
  
  const columns = columnsTableMenu.map((col) => {
    if (col.dataIndex === "tenDichVu") {
      return {
        ...col,
        options: dichVus.map(it => ({
          value: it.tenDichVu,
          label: it.tenDichVu
        }))
      };
    } else return col;
  });

  useEffect(() => {
  }, [])

  useEffect(() => {

  }, [dataSource])
  return (
    <div className="service-table-container">
      <Space
        direction="vertical"
        className="service-space"
      >
        <Row gutter={[8, 8]}>
          <Col xs={24} md={24} sm={24} lg={24} xl={24}>
            <TableInputAdd
              column={columns}
              data={dataSource}
              setData={setDataSource}
              pagination={false}
              // rowSelection={{
              //   onSelect: onSelectRow,
              //   selectedRowKeys: selectedRowKeys
              // }}
              dichVus={dichVus}
              count={count}
              setCount={setCount}
            />
          </Col>
        </Row>
      </Space>
    </div>
  );
})

export default ServiceTable;
